import { createFileRoute } from "@tanstack/react-router";
import { memo, useEffect } from "react";
import { useBrand } from "@/src/brand";
import { injectViewmodel } from "@/src/infrastructure/di";
import PageLayout from "@/src/presentation/components/page-layout";
import RecentAlerts from "@/src/presentation/components/recent-alerts";
import ViewmodelWrapper from "@/src/presentation/components/viewmodel-wrapper";
import DevicesViewModel from "@/src/presentation/view-models/devices-viewmodel";
import DeviceClaimModal from "./_components/device-claim-modal";
import DeviceControls, { InjectedDeviceAddDevicesButton } from "./_components/device-controls";
import DeviceSearch from "./_components/device-search";
import DeviceTypeFilter from "./_components/device-type-filter";
import DevicesView from "./_components/devices-view";
import EmptyState from "./_components/empty-state";
import MissingPropertyProfileModal from "./_components/missing-property-profile-modal";

const State = memo(
  injectViewmodel(DevicesViewModel, function State({ model }) {
    useEffect(() => {
      model.resetForAccountBoundary();
      void model.fetchDevices();
    }, [model]);
    return null;
  })
);

function DevicesPage() {
  const brand = useBrand();
  const showTopAddDeviceButton = brand.features.addDeviceButtonPlacement === "top";
  const showBottomAddDeviceButton = brand.features.addDeviceButtonPlacement === "bottom";

  return (
    <ViewmodelWrapper global={true} type={DevicesViewModel}>
      <State />
      <PageLayout title="My Devices" description="Manage and monitor all your water devices">
        <RecentAlerts />

        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <DeviceSearch />
          {brand.features.deviceTypeFilter && <DeviceTypeFilter />}
        </div>

        {brand.features.deviceControls && (
          <DeviceControls showAddDevicesButton={showTopAddDeviceButton} />
        )}

        <DevicesView />
        <EmptyState />
        {showBottomAddDeviceButton && (
          <div className="flex justify-center pt-2">
            <InjectedDeviceAddDevicesButton />
          </div>
        )}
        <DeviceClaimModal />
        <MissingPropertyProfileModal />
      </PageLayout>
    </ViewmodelWrapper>
  );
}

export const Route = createFileRoute("/_authenticated/dashboard/devices/")({
  component: DevicesPage,
});
